"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _BackblazePlugin = /*#__PURE__*/ _interop_require_default(require("./BackblazePlugin"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const config = {
    builder: _BackblazePlugin.default,
    id: 'backblaze',
    title: 'Backblaze',
    recoveryTitle: 'Backblaze B2',
    version: '0.0.6',
    logo: 'plugins/backblaze.png',
    tags: 'Storage',
    description: 'Backblaze B2 is enterprise-grade, S3 compatible storage that companies around the world use to store and serve data while improving their cloud OpEx vs. Amazon S3 and others.',
    inputs: {
        title: 'Configure Backblaze B2',
        items: [
            {
                key: 'bucket',
                label: 'Bucket Name',
                placeholder: 'Bucket Name',
                type: _nocodbsdk.XcType.SingleLineText,
                required: true
            },
            {
                key: 'region',
                label: 'Region',
                placeholder: 'e.g. us-west-001',
                type: _nocodbsdk.XcType.SingleLineText,
                required: true
            },
            {
                key: 'access_key',
                label: 'Access Key',
                placeholder: 'i.e. keyID in App Keys',
                type: _nocodbsdk.XcType.SingleLineText,
                required: true
            },
            {
                key: 'access_secret',
                label: 'Access Secret',
                placeholder: 'i.e. applicationKey in App Keys',
                type: _nocodbsdk.XcType.Password,
                required: true
            },
            {
                key: 'acl',
                label: 'Access Control Lists (ACL)',
                placeholder: 'Default set to public-read',
                type: _nocodbsdk.XcType.SingleLineText,
                required: false
            }
        ],
        actions: [
            {
                label: 'Test',
                placeholder: 'Test',
                key: 'test',
                actionType: _nocodbsdk.XcActionType.TEST,
                type: _nocodbsdk.XcType.Button
            },
            {
                label: 'Save',
                placeholder: 'Save',
                key: 'save',
                actionType: _nocodbsdk.XcActionType.SUBMIT,
                type: _nocodbsdk.XcType.Button
            }
        ],
        msgOnInstall: 'Successfully configured! Attachments will now be stored in Backblaze B2.',
        msgOnUninstall: ''
    },
    category: 'Storage'
};
const _default = config;
